import { InjectionToken } from '@angular/core';

import { IExporter } from '../interfaces';

/**
 * Injection token that stores all registered exporter strategies.
 */
export const EXPORTERS = new InjectionToken<readonly IExporter[]>('EXPORTERS');
